// /operations/offices/{id}/
import './workload.scss';
import React, { useEffect, useState, useCallback } from 'react';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import { ReactComponent as DotIcon } from '../../assets/frame.svg';
import Modal from '../../components/Modal/Modal';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';
import InputWithIcon from '../../components/InputWithIcon/InputWithIcon';
import base from '../../apis';
import Spinner from '../../components/Spinner/Spinner';
import { toast } from 'react-toastify';
import MenuDropDown from '../../components/MenuDropDown/MenuDropDown';
import { useSelector } from 'react-redux';
import { ReactComponent as Avatar } from '../../images/avatarDefault.svg';
import avatar from '../../images/avatarDefault.svg';

const Tabledropdown = ({ label, children, active = false }) => {
  const [show, setshow] = useState(active);

  return (
    <tbody>
      <tr onClick={() => setshow((isShow) => !isShow)}>{label}</tr>
      <tr>{show && children}</tr>
    </tbody>
  );
};

const Workload = () => {
  const [currentMemberId, setCurrentMemberId] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [addNewModalOpen, setAddNewModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [membersData, setmembersData] = useState([]);
  const [originalMembersData, setOriginalMembersData] = useState();
  const [officeState, setOfficeState] = useState();
  const [userData, setUserData] = useState([]);

  const [searchParams, setSearchParams] = useState({
    executive: '',
  });
  const closeAllModals = () => {
    setAddNewModalOpen(false);
    setConfirmModalOpen(false);
    setDeleteModalOpen(false);
  };
  const [assignableExecutives, setAssignableExecutives] = useState({
    isLoading: false,
    data: null,
  });
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const snr_marketer_id = useSelector((state) => state.auth.marketerDetails.id);

  const fetchAgentsWorkload = useCallback(async () => {
    setIsLoading(true);
    try {
      const { data } = await base.get(`operations/snr_marketers/${snr_marketer_id}/team/`);
      if (data?.length === 0) {
        toast.warn('You have not been assigned to a team yet. See Administrator for more details.');
      }
      setmembersData(data[0]?.members || []);
      setOriginalMembersData(data[0]?.members || []);
      if (data[0]?.members?.length === 0) {
        toast.warn('No Markerting Executives');
      }
    } catch (error) {
      toast.error('Error loading Marketing Executives');
    } finally {
      setIsLoading(false);
    }
  }, [snr_marketer_id]);

  useEffect(() => {
    fetchAgentsWorkload();
  }, [fetchAgentsWorkload]);

  const onReassign = (office) => {
    setOfficeState(office);

    const newMarketingExecutives = membersData.filter((member) => !(member.id === office.marketer_id));
    setAssignableExecutives({ isLoading: false, data: newMarketingExecutives });
    setAddNewModalOpen(true);
  };

  const selectedAgent = ({ user, memberId }) => {
    setConfirmModalOpen(true);
    setCurrentUser(user);
    setCurrentMemberId(memberId);
  };

  const confirmReassign = async () => {
    setIsLoading(true);
    closeAllModals();
    try {
      const {
        branch,
        phone,
        address,
        city,
        state,
        web_link,
        location,
        company_id,
        id,
        zip_code,
        manager_name,
        manager_email,
        manager_phone,
        size,
        team_id,
      } = officeState;
      await base.put(`operations/offices/${officeState.id}/`, {
        branch,
        phone,
        address,
        city,
        state,
        web_link,
        location,
        company_id,
        id,
        zip_code,
        manager_name,
        manager_email,
        manager_phone,
        size,
        team_id,
        marketer_id: currentMemberId,
      });
      toast.success('Office Reassigned Successfully');
      fetchAgentsWorkload();
    } catch (error) {
      toast.error('Error reassigning Marketing Executive');
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDelete = async () => {
    closeAllModals();
    setIsLoading(true);
    try {
      const {
        branch,
        phone,
        address,
        city,
        state,
        web_link,
        location,
        company_id,
        id,
        zip_code,
        manager_name,
        manager_email,
        manager_phone,
        size,
        team_id,
      } = officeState;
      await base.put(`operations/offices/${officeState.id}/`, {
        branch,
        phone,
        address,
        city,
        state,
        web_link,
        location,
        company_id,
        id,
        zip_code,
        manager_name,
        manager_email,
        manager_phone,
        size,
        team_id,
        marketer_id: null,
      });
      toast.success('Office Deleted Successfully');
      fetchAgentsWorkload();
    } catch (error) {
      toast.error('Error deleting Office');
    } finally {
      setIsLoading(false);
    }
  };

  // const onAssignMemberSearch = async (e) => {
  //   const value = e.target.value;
  //   if (value === '') {
  //     setAssignableExecutives({ isLoading: false, data: membersData });
  //   } else {}
  // };

  const onDelete = ({ office, userData }) => {
    setOfficeState(office);
    setUserData(userData);
    setDeleteModalOpen(true);
  };

  const onChangeSearchParams = (e) => {
    const { name, value } = e.target;
    setSearchParams((previousState) => ({
      ...previousState,
      [name]: value,
    }));
  };

  const onSearchSubmit = (e) => {
    e.preventDefault();
    const { executive } = searchParams;
    if (!executive) {
      setmembersData(originalMembersData);
      return;
    }

    const filteredMembers = originalMembersData.filter((member) =>
      (member.user.first_name.toLowerCase() || member.user.last_name.toLowerCase).includes(executive.toLowerCase())
    );
    setmembersData(filteredMembers);
  };

  return (
    <>
      <Modal open={deleteModalOpen} onClose={() => setDeleteModalOpen(false)} style={{ width: '50vw' }}>
        <div className="mod2">
          <div className="mod2header">
            <div>
              <p>{officeState?.branch}</p>
              <p>{officeState?.city}</p>
            </div>
          </div>
          <div className="centerer">
            <p>
              You are deleting the above office from {userData?.first_name} {userData?.last_name}
            </p>
            <div>
              <Button text="Cancel" onClick={() => setDeleteModalOpen(false)} />
              <Button text="Confirm" onClick={() => confirmDelete()} />
            </div>
          </div>
        </div>
      </Modal>
      <Modal open={confirmModalOpen} onClose={() => setConfirmModalOpen(false)} style={{ width: '50vw' }}>
        <div className="mod2">
          <div className="mod2header">
            <div>
              <p>{officeState?.branch}</p>
              <p>{officeState?.city}</p>
            </div>
            {/* <CloseIcon
							onClick={() => setModalOpen2(false)}
							style={{ fill: '#1378A5', cursor: 'pointer' }}
						/>{' '} */}
          </div>
          <div className="centerer">
            <p>
              You are assigning the above office to {currentUser?.first_name} {currentUser?.last_name}
            </p>
            <div>
              <Button text="Cancel" onClick={() => setConfirmModalOpen(false)} />
              <Button text="Confirm" onClick={() => confirmReassign()} />
            </div>
          </div>
        </div>
      </Modal>
      <Modal open={addNewModalOpen} onClose={() => setAddNewModalOpen(false)}>
        <>
          <div
            className="mod2 mod3"
            style={{
              maxWidth: '80vw',
              maxHeight: '80vh',
              overflowY: 'scroll',
              minWidth: '70vw',
            }}>
            <div className="mod2header mod3header" style={{ backgroundColor: 'white', position: 'sticky', top: 0 }}>
              <div className="header_info">
                <p className="header_item">{officeState?.branch}</p>
                <p className="header_item">{officeState?.city}</p>
                <InputWithIcon
                  className="header_item"
                  placeholderText={'Enter a name'}
                  style={{
                    fontSize: '18px',
                    padding: '10px 20px',
                    width: '350px',
                  }}
                />
              </div>
              <CloseIcon
                className="close_icon"
                onClick={() => {
                  setAddNewModalOpen(false);
                }}
                style={{ fill: '#1378A5', cursor: 'pointer' }}
                width="36px"
                height="18px"
              />
            </div>
            <div className="itemholder_grid">
              {!assignableExecutives.isLoading ? (
                assignableExecutives.data?.map(({ id, user }) => (
                  <AgentItem key={id} user={user} memberId={id} selectedAgent={selectedAgent} />
                ))
              ) : (
                <Spinner overlay={false} />
              )}
            </div>
          </div>
        </>
      </Modal>
      <div className="workload">
        <>
          {isLoading && <Spinner />}
          <form className="modinputs" onSubmit={onSearchSubmit}>
            <Input
              placeholder="Enter Marketing Executive"
              name="executive"
              value={searchParams.executive}
              onChange={onChangeSearchParams}
              style={{ fontSize: '18px', padding: '10px 20px' }}
            />
            <Input placeholder="Enter State" style={{ fontSize: '18px', padding: '10px 20px' }} />
            <Input placeholder="Enter City" style={{ fontSize: '18px', padding: '10px 20px' }} />
            <Input placeholder="Enter Office Name" style={{ fontSize: '18px', padding: '10px 20px' }} />
            <Button
              style={{
                width: '100px',
                fontSize: '18px',
                padding: '10px',
                color: 'white',
                backgroundColor: 'var(--primary-color)',
                display: 'block',
              }}
              text="Filter"
            />
          </form>
          <h3>{new Date().toLocaleString('en', { month: 'long' })}</h3>
          <table className="table">
            {membersData.map((member, index) => (
              <Tabledropdown
                active={index === 0}
                key={index}
                label={
                  <>
                    <td className="td_wrapper">
                      <img className="agent_img" src={avatar} alt="" />
                      {member.user.first_name} {member.user.last_name}
                    </td>
                    <td className="assigned_offices">
                      {member.offices.length === 0
                        ? 'No Offices Assigned'
                        : `${member.offices.length} Offices Assigned`}
                    </td>
                  </>
                }>
                <td className="td_wrapper"></td>
                <td className="assigned_offices">
                  {member.offices.map((office, index) => (
                    <OfficeInfo
                      key={office.id}
                      officeName={office.branch}
                      cityName={office.state.toUpperCase()}
                      countyName={office.city}
                      onReassign={onReassign}
                      onDelete={onDelete}
                      officeData={office}
                      userData={member.user}
                    />
                  ))}
                </td>
              </Tabledropdown>
            ))}
          </table>
        </>
      </div>
    </>
  );
};

export default Workload;

const OfficeInfo = ({ officeName, cityName, countyName, onClick, onReassign, officeData, onDelete, userData }) => {
  return (
    <div className="office_info" onClick={onClick}>
      <p>{officeName}</p>
      <p>{cityName}</p>
      <p>{countyName}</p>
      <MenuDropDown
        activator={<DotIcon className="dots" />}
        onReassign={onReassign}
        officeData={officeData}
        onDelete={onDelete}
        userData={userData}>
        <OfficePopUp onReassign={onReassign} officeData={officeData} onDelete={onDelete} userData={userData} />
      </MenuDropDown>
    </div>
  );
};

const AgentItem = ({ name, selectedAgent, user, memberId }) => {
  const { first_name, last_name } = user;
  if (first_name && last_name) {
    return (
      <div className="agent_card" onClick={() => selectedAgent({ user, memberId })}>
        {/* <AgentImage width={'100px'} /> */}
        <Avatar width={'100px'} />
        <p>{`${first_name} ${last_name}`}</p>
      </div>
    );
  } else {
    return null;
  }
};

const OfficePopUp = ({ name, onClick, onReassign, officeData: office, onDelete, userData }) => {
  return (
    <div className="office_options">
      <div onClick={() => onReassign(office)} className="reassign_btn">
        <p>Reassign Office</p>
      </div>
      <div onClick={() => onDelete({ office, userData })} className="reassign_btn">
        <p>Delete Office</p>
      </div>
    </div>
  );
};
